import { warehouseClient } from "@/infrastructure/http/warehouseClient";
import type { InventoryBalanceListResponse, CloseBalanceResult, ApiEnvelope } from "@/domain/types";

export async function listInventoryBalance(params: {
  page?: number;
  limit?: number;
  periodYear?: number;
  periodMonth?: number;
  warehouseId?: string;
  productId?: string;
  status?: string;
  categoryId?: string;
}): Promise<InventoryBalanceListResponse> {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.periodYear) query.set("periodYear", String(params.periodYear));
  if (params.periodMonth) query.set("periodMonth", String(params.periodMonth));
  if (params.warehouseId) query.set("warehouseId", params.warehouseId);
  if (params.productId) query.set("productId", params.productId);
  if (params.status) query.set("status", params.status);
  if (params.categoryId) query.set("categoryId", params.categoryId);
  const response = await warehouseClient.get<ApiEnvelope<InventoryBalanceListResponse>>(`/inventory-balance?${query.toString()}`);
  return response.data.data;
}

export async function closePeriod(periodYear: number, periodMonth: number): Promise<CloseBalanceResult> {
  const response = await warehouseClient.post<ApiEnvelope<CloseBalanceResult>>("/inventory-balance/close", { periodYear, periodMonth });
  return response.data.data;
}
